import './video-footer.scss'

import { RoomName } from '../RoomName'
import { useZoomContext } from '../../../../context/ZoomContext'
import { getDeviceType } from '../../util/platform'
import { SentryFeedbackButton } from '../Dev/SentryFeedbackButton'
import { IntercomSelector } from '../../../../components/IntercomSelector'
import { LanguageSelector } from '../../../../components/LanguageSelector'
import { ControlsSideLeft } from './ControlsStyled'

const ControlsLeft = () => {
    const { sidebarMode } = useZoomContext()
    const type: 'mobile' | 'desktop' = getDeviceType()

    return (
        <ControlsSideLeft showSidebar={sidebarMode}>
            {type !== 'mobile' && <LanguageSelector />}
            {type !== 'mobile' && <SentryFeedbackButton />}
            {type !== 'mobile' && <IntercomSelector />}
            {type !== 'mobile' && <RoomName />}
        </ControlsSideLeft>
    )
}

export default ControlsLeft